import API_URL from '../config/config';

let policy = { minCharacters: 3 };
let expires = 0;
let pending;
const listeners = new Set();
export const getAddressSearchPolicy = () => policy;
export const searchCharacterCount = (input) => Array.from(String(input || '').trim()).length;
export const searchMinimumMessage = (minimum) => `Selected address should be at least ${minimum} letters long`;
export const subscribeAddressSearchPolicy = (listener) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};
export function updateAddressSearchPolicy(value) {
  if (!Number.isInteger(value?.minCharacters) || value.minCharacters < 3 || value.minCharacters > 20) {
    throw new Error('Address search settings are unavailable. Please try again.');
  }
  policy = { minCharacters: value.minCharacters };
  expires = Date.now() + 30000;
  listeners.forEach(listener => listener(policy));
  return policy;
}
export function loadAddressSearchPolicy() {
  if (Date.now() < expires) return Promise.resolve(policy);
  if (pending) return pending;
  pending = (async () => {
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), 10000);
    try {
      const response = await fetch(`${String(API_URL).trim()}/maps/search-policy`, {
        cache: 'no-store', credentials: 'include', signal: controller.signal,
      });
      const data = await response.json();
      if (!response.ok || data?.success !== true) throw new Error('Address search settings are unavailable. Please try again.');
      return updateAddressSearchPolicy(data);
    } finally {
      clearTimeout(timer);
    }
  })().finally(() => { pending = undefined; });
  return pending;
}
